import React, { Component } from 'react'
import Store from './store'
import { observer } from 'mobx-react'
import Main from './Main'
import QRCode from 'qrcode.react'
import { Modal } from 'hljd'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  componentDidMount() {
    this.store.getCertifyInfo()
  }

  render() {
    const { visible, shortUrl } = this.store

    const { indexStore } = this.props
    return (
      <>
        <Main store={this.store} indexStore={indexStore} />

        <Modal
          title="扫一扫"
          visible={visible}
          onCancel={this.store.showModal}
          footer={null}
        >
          <div style={{ margin: '10px auto', width: 180 }}>
            <QRCode value={shortUrl} size={180} />
          </div>
          <p style={{ textAlign: 'center' }}>请用支付宝APP扫码认证</p>
        </Modal>
      </>
    )
  }
}
